import { Link } from 'react-router-dom'
import { useState, useEffect } from 'react'
import styles from './Header.module.scss'

function scrollToSection(id) {
    setTimeout(() => {
        const el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 0)
}

function Header() {
    const [isOpen, setIsOpen] = useState(false)
    const [isScrolled, setIsScrolled] = useState(false)

    // Отслеживаем скролл для фиксации шапки
    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 20) {
                setIsScrolled(true)
            } else {
                setIsScrolled(false)
            }
        }

        window.addEventListener('scroll', handleScroll)
        return () => window.removeEventListener('scroll', handleScroll)
    }, [])

    // Блокируем скролл страницы, когда открыта шторка
    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = 'hidden'
        } else {
            document.body.style.overflow = ''
        }
        return () => {
            document.body.style.overflow = ''
        }
    }, [isOpen])

    const handleMobileNav = (sectionId) => {
        setIsOpen(false)
        scrollToSection(sectionId)
    }

    return (
        <header className={`${styles.header} ${isScrolled ? styles.scrolled : ''}`}>
            <div className={`container ${styles.headerContainer}`}>
                {/* Логотип */}
                <Link className={styles.headerLogo} to='/'>
                    <img src='/img/Header/logo.svg' alt='Логотип' />
                </Link>

                {/* Навигация (Десктоп) */}
                <nav className={styles.navLinks}>
                    <button className={styles.navLink} onClick={() => scrollToSection('courses')}>
                        Направления
                    </button>
                    <button className={styles.navLink} onClick={() => scrollToSection('achievements')}>
                        Результаты
                    </button>
                    <button className={styles.navLink} onClick={() => scrollToSection('pricing')}>
                        Стоимость
                    </button>
                    <button className={styles.navLink} onClick={() => scrollToSection('contacts')}>
                        Контакты
                    </button>
                </nav>

                {/* Правая часть (Десктопная кнопка + Иконка бургера) */}
                <div className={styles.rightSide}>
                    <button
                        className={styles.ctaButton}
                        onClick={() => scrollToSection('form-section')}
                    >
                        Записаться
                    </button>

                    <button
                        className={styles.burgerIcon}
                        onClick={() => setIsOpen(true)}
                        aria-label='Открыть меню'
                    >
                        {/* Иконка Menu (бургер) */}
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="4" y1="12" x2="20" y2="12"></line>
                            <line x1="4" y1="6" x2="20" y2="6"></line>
                            <line x1="4" y1="18" x2="20" y2="18"></line>
                        </svg>
                    </button>
                </div>
            </div>

            {/* Выезжающее мобильное меню (Drawer / Sheet) */}
            <div className={`${styles.sheetRoot} ${isOpen ? styles.open : ''}`}>
                <div
                    className={styles.sheetBackdrop}
                    onClick={() => setIsOpen(false)}
                />

                <aside className={styles.sheetPanel}>
                    <div className={styles.mobileHeader}>
                        <Link to="/" className={styles.mobileLogo} onClick={() => setIsOpen(false)}>
                            <img src='/img/Header/logo.svg' alt='Логотип' />
                        </Link>
                        <button
                            className={styles.closeIcon}
                            onClick={() => setIsOpen(false)}
                        >
                            {/* Иконка X (крестик) */}
                            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <line x1="18" y1="6" x2="6" y2="18"></line>
                                <line x1="6" y1="6" x2="18" y2="18"></line>
                            </svg>
                        </button>
                    </div>

                    <div className={styles.mobileNav}>
                        <button className={styles.mobileLink} onClick={() => handleMobileNav('courses')}>
                            Направления
                        </button>
                        <button className={styles.mobileLink} onClick={() => handleMobileNav('achievements')}>
                            Результаты
                        </button>
                        <button className={styles.mobileLink} onClick={() => handleMobileNav('pricing')}>
                            Стоимость
                        </button>
                        <button className={styles.mobileLink} onClick={() => handleMobileNav('contacts')}>
                            Контакты
                        </button>
                    </div>

                    <div className={styles.mobileFooter}>
                        <button
                            className={styles.mobileCtaButton}
                            onClick={() => handleMobileNav('form-section')}
                        >
                            Записаться
                        </button>
                    </div>
                </aside>
            </div>
        </header>
    )
}

export default Header
